import { Dialog } from '@headlessui/react'
import React, { useState } from 'react'
import { report } from './utilities/constants'
import { useDispatch } from 'react-redux'
import { reportVideoQuality } from '../../redux/personaliseLessons/reportVideoSlice'
import { toast } from 'react-toastify'
import useWindowSize from '../../hooks/useWindowSize'


const ReportModal = ({showReportModal, setShowReportModal, user_id, course_name, lessonDetails }) => {

    const [ videoProblem, setVideoProblem ] = useState(false)
    const [ soundProblem, setSoundProblem ] = useState(false)
    const [ captionProblem, setCaptionProblem ] = useState(false)
    const [ customizedReport, setCustomizedReport ] = useState('')

    const dispatch = useDispatch()
    const { width } = useWindowSize()
    
    console.log(lessonDetails?.video_url, lessonDetails?.start_time, lessonDetails?.stop_time, lessonDetails?.lesson_id);

    const handleCustomizedText = () => {
        console.log(videoProblem, soundProblem, captionProblem, customizedReport);
        let reason = ""
        if (videoProblem){
            reason += "1. Blurry, cuts out, or looks strange in some way." + " "
        }
        if (soundProblem){
            reason += "2. Hard to hear, not matched with video, or missing in some partts" + " "
        }
        if (captionProblem){
            reason += "3. Missing, hard to read, not matched with sound, misspellings, or poor translations." + " "
        }
        dispatch(reportVideoQuality({ user_id: user_id, course_name: course_name, video_url: lessonDetails?.video_url, reason: reason, comments: customizedReport, video_start: lessonDetails?.start_time, video_end: lessonDetails?.stop_time, lesson_id: lessonDetails?.lesson_id}))
        setShowReportModal(false)
        toast.success("Successfully Submitted Your report")
        setCustomizedReport("")

    }

    return (
        <Dialog open={showReportModal} onClose={() => setShowReportModal(false)}
            as="div"
            style={{ zIndex: '9999999999' }}
            className="fixed inset-0 z-10 flex flex-col items-center justify-center">
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
            <Dialog.Title />
            <Dialog.Description />
            <div className={`bg-[#2D4F71] z-10 w-[90%] max-w-[500px] ${width >= 560 ? 'h-[500px]' : 'h-3/5'} rounded-xl text-white p-3`}>
                <h2 className='mt-4 text-center text-2xl font-semibold mb-4'>Report Video</h2>
                <div className='flex items-start'>
                    <input 
                        type="checkbox"
                        id='video'
                        value={videoProblem}
                        onChange={(e) => setVideoProblem(e.target.checked)}
                        className='bg-transparent w-4 h-4 checked:bg-[#7FC241] border-white rounded'
                    />
                    <div className='-mt-0.5 ml-2'>
                        <p>Video Problem</p>
                        <p className='text-xs font-medium leading-[14.5px]'>Blurry, cuts out, or looks strange in some way.</p>
                    </div>
                </div>
                <div className='flex items-start mt-4'>
                    <input 
                        type="checkbox"
                        id=''
                        value={soundProblem}
                        onChange={(e) => setSoundProblem(e.target.checked)}
                        className='bg-transparent w-4 h-4 checked:bg-[#7FC241] border-white rounded'
                    />
                    <div className='-mt-0.5 ml-2'>
                        <p>Sound Problem</p>
                        <p className='text-xs font-medium leading-[14.5px]'>Hard to hear, not matched with video, or missing in some partts</p>
                    </div>
                </div>
                <div className='flex items-start mt-4'>
                    <input 
                        type="checkbox"
                        id=''
                        value={captionProblem}
                        onChange={(e) => setCaptionProblem(e.target.checked)}
                        className='bg-transparent w-4 h-4 checked:bg-[#7FC241] border-white rounded'
                    />
                    <div className='-mt-0.5 ml-2'>
                        <p>Subtitles or Caption Problem</p>
                        <p className='text-xs font-medium leading-[14.5px]'>Missing, hard to read, not matched with sound, misspellings, or poor translations.</p>
                    </div>
                </div>
                <div className='mt-5 flex flex-col'>
                    <p className='mb-1.5'>It’s Something Else?</p>
                    <form onSubmit={handleCustomizedText}>
                        <textarea 
                            type="text"
                            placeholder='Write a comment'
                            value={customizedReport}
                            onChange={(e) => setCustomizedReport(e.target.value)}
                            className='w-full bg-[#17395A] min-h-[120px] rounded-lg focus:outline-none answer_text border-none placeholder:text-sm placeholder:text-white/50 text-sm py-3'
                        />
                        <button type='submit' className='float-right w-[40%] py-3.5 rounded-xl font-semibold bg-[#7FC241] mt-3'>
                            Submit
                        </button>
                    </form>
                </div>
            </div>
        </Dialog>
    )
}

export default ReportModal